import { render } from "./ServiceOcean.vue?vue&type=template&id=9cbe4814"
import script from "./ServiceOcean.vue?vue&type=script&lang=js"
export * from "./ServiceOcean.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__